import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Researchs from "./Researchs";




export default function Research(){
    return(
        <div className="Research">
            <Navbar/>
            <Researchs/>
            <Footer/>
        </div>
    )
}